import { PropsWithChildren, Component, ReactNode, SetStateAction, Dispatch } from "react";

interface IErrorBoundary {
  hasError: boolean;
}

interface iProps extends PropsWithChildren {
  errorMessage?: string;
  fallback?: ReactNode;
  setError?: Dispatch<SetStateAction<any>>;
}

export default class ErrorBoundary extends Component<iProps, IErrorBoundary> {
  constructor(props: iProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }
  
  componentDidCatch(error: any, info: any) {
    this.props.setError?.(error);
    console.error(error, info);
  }

  public resetErrorHandler() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback ? this.props.fallback : this.props.errorMessage ? <div>{this.props.errorMessage}</div> : null;
    }

    return this.props.children;
  }
}